import { FunctionComponent } from "react";

import Phone from "@assets/icons/phone.svg?url";
import Checked from "@assets/icons/checked.svg?url";
import Failed from "@assets/icons/failed.svg?url";
import Refresh from "@assets/icons/refresh.svg?url";

import { Spinner } from "../Spinner/Spinner";

export interface PhoneIconProps {
	status: "checked" | "failed" | "refresh" | "searching";
}

export const PhoneIcon: FunctionComponent<PhoneIconProps> = ({ status }) => {
	return (
		<div className="group relative z-100 mr-1 flex h-[20px] w-[20px] items-center justify-center">
			{status === "checked" && (
				<img alt="checked" className="absolute right-[-1px] top-[-1px]" src={Checked} />
			)}
			{status === "failed" && (
				<img alt="failed" className="absolute right-[-1px] top-[-1px]" src={Failed} />
			)}
			{status === "refresh" && (
				<img alt="refresh" className="absolute right-[-1px] top-[-1px]" src={Refresh} />
			)}
			{status === "searching" && <Spinner color="#4d66f5" />}
			{status !== "searching" && <img alt="Phone" className="h-[20px] w-[20px]" src={Phone} />}
		</div>
	);
};
